import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, Events, ToastController  } from 'ionic-angular';
import { EbsWebServiceGlobals } from "../../services/ebsWebServiceGlobals";
import { EbsWebService } from "../../services/ebsWebService";
import { Storage } from '@ionic/storage';

@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})

export class LoginPage {

  username:string = "";
  password:string = "";
  showLoginScreen:boolean = false;
  loginObject:any = "";

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public events: Events,
              private _ebsWebService: EbsWebService,
              public _ebsWebServiceGlobals: EbsWebServiceGlobals,
              private toastCtrl: ToastController,
              private _storage: Storage) {
    let logoutURL = this.navParams.get('actionURL');

    if(typeof this.navParams.get('loginObject') != "undefined" && this.navParams.get('loginObject') != "" && this.navParams.get('loginObject') !== null) {
      this.loginObject = this.navParams.get('loginObject');
      this.setStyles();
      this._storage.set("loginobject", this.loginObject);
    } else {
      this._storage.get('loginobject').then((loginObject) => {
        if(typeof loginObject != "undefined") {
          this.loginObject = loginObject;
          this.setStyles();
        }
      })
    }

    if (logoutURL != "" && logoutURL != null && logoutURL != undefined) {
      this.logout(logoutURL);
    } else {
      this.showLoginScreen = true;
    }
  }

  checkEnter(event) {
    var keynum;
    var enttest;

    if (window.event) {
        keynum = event.keyCode;
    } else {
        if (event.which) {
            keynum = event.which;
        }
    }

    enttest = 13; //Enter KeyCode
    if (enttest == keynum) {
        this.login()
        return false;
    }
}

  setStyles() {
    if (typeof this.loginObject != "undefined" && this.loginObject != null) {
      document.body.style.setProperty('--InputTextColor', this.loginObject.InputTextColor);
      document.body.style.setProperty('--TitleColor', this.loginObject.TitleColor);
      document.body.style.setProperty('--BackgroundColor', this.loginObject.LoginBackground);
      document.body.style.setProperty('--ButtonColor', this.loginObject.ButtonBackground);
      document.body.style.setProperty('--ButtonTextColor', this.loginObject.ButtonTextColor);
    }
  }

  logout(logoutURL) {
    this._ebsWebService.postData(logoutURL,null).subscribe(res=>{
      this._ebsWebServiceGlobals.setUserHash('');
      window.location.reload();
    });
  }

  login() {
    let loginUrl = this._ebsWebServiceGlobals.getLoginUrl();
    if (loginUrl!="") {
      let params = {
        'user': this.username,
        'pwd': this.password
      };

      if(params.user == "" || params.user == " " || params.user === null || params.pwd == "" || params.pwd == " " || params.pwd === null) {
        let toast = this.toastCtrl.create({
          message: 'Daten dürfen nicht leer sein!',
          duration: 3000,
          position: 'bottom'
        });
        toast.present();
      }
      else {
        this._ebsWebService.postData(loginUrl,params).subscribe(res=>{
          //TODO: PRÜFEN WAS VOM WEBSERVICE KOMMT, WEITERLEITUNG ODER FEHLERMELDUNG ANZEIGEN

          if (res.UserKey != null && res.UserKey != '' && typeof res.UserKey != 'undefined') {
            this._ebsWebServiceGlobals.setUserHash(res.UserKey);
          }
          this.events.publish('setting:LoginPage');
        });
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts